<template lang="pug">
.chart
    apexchart(type="bar" :options="options" :series="series" height='500' width="1000")
</template>

<script>
export default {
  name: 'DashboardChart',
  props: {
    invoices: {
      type: Array
    }
  },
  methods: {
    formatter (value) {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value)
    }
  },
  computed: {
    options: function () {
      return {
        chart: {
          type: 'bar',
          height: 350
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded',
            borderRadius: 10
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: this.invoices.map(invoice => invoice.folio)
        },
        yaxis: {
          labels: {
            formatter: this.formatter
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: this.formatter
          }
        },
        colors: ['#3DCB6F', '#D8212D']
      }
    },
    series: function () {
      return [
        {
          name: 'Invoiced',
          data: this.invoices.map(invoice => invoice.amount)
        },
        {
          name: 'Paid',
          data: this.invoices.map(invoice => invoice.balance)
        }
      ]
    }
  }
}
</script>

<style lang="scss" >
.chart {
    padding: 1rem 0;
}
</style>
